import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Glyphicon } from 'react-bootstrap'
import { inject, observer } from 'mobx-react';
import { AlertGenerator } from '../components/AlertGenerator';
import { Checkbox } from 'react-bootstrap';

@inject('configurationStore')
@observer
class CommunicationPreference extends Component {
  displayName = CommunicationPreference.name;

  componentDidMount() {
    const currentCustomerId = parseInt(this.props.match.params.customerId, 10);
    this.props.configurationStore.setCurrentCustomerId(currentCustomerId);
    this.props.configurationStore.getBlockableTypes();
    this.props.configurationStore.getNotificationTypes();
  }
  
  render() {
    const { configurationStore, } = this.props;
    if (configurationStore.isLoading || configurationStore.blockedNotificationTypes == null)
      return <p><em>Loading...</em></p>;

    const { 
      notificationTypes,
      alertMessage, hideAlert, customer,
      blockNotificationType,
      blockedNotificationTypes
    } = configurationStore;
    
    return (
      <div>
        <AlertGenerator alertMessage={alertMessage} hideAlert={hideAlert}></AlertGenerator>
        <h1>{customer.name} - Communication Preferences</h1>
        <Link to={`/customer/${customer.id}`} className="mr-5">
            <Glyphicon glyph="arrow-left" /> Back to Customer
        </Link>
        
        <hr></hr>
        <h4>Checking a type means that a patron may unsubscribe from that type.</h4>
        {
          notificationTypes.filter(type => type.name.toLowerCase() !== "ListMessage".toLowerCase())
            .map(type => {
              const checked = blockedNotificationTypes.findIndex(t => t.notificationTypeId === type.id) !== -1
              return <Checkbox defaultChecked={checked} 
                onChange={blockNotificationType.bind(null, type.id)} key={type.id}>{type.name}</Checkbox>
            })
        }
      </div>
    );
  }
}

//checked={this.state.customTemplate} onChange={this.updateCheckbox.bind(this, 'customTemplate')}

export { CommunicationPreference };